module.exports = __webpack_public_path__ + "static/p07_borreguitoR-0dad71a85c0356647c21331bea9bfe4d.png";